(function Favorite($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		if ($('.favorite').length) {
			$('.favorite').click(function favoriteIt() {
				var item_id  = $(this).data('item-id'),
					redirect = $(this).data('uri'),
					type     = $(this).data('type'),
					message;

				if ($(this).hasClass('favorite-active')) {
					$(this).removeClass('favorite-active');
					$(this).css('color', '#FFF');

					Adzuki.Ajax.get('/ClientFavorites/remove/' + item_id + '/' + type + '/' + redirect).then(function success(response) {
						if (response.response !== 'success') {
							console.log('cannot unfavorite');
						}
					});
				} else {
					$(this).addClass('favorite-active');
					$(this).css('color', 'red');

					if ($(this).data('message') !== 'undefined') {
						message = $(this).data('message');
						$(this).addClass('hidden');
						Adzuki.StatusMessage(null, message, 'Favorited');
					}

					Adzuki.Ajax.get('/ClientFavorites/add/' + item_id + '/' + type + '/' + redirect).then(function success(response) {
						if (response.response === 'not_logged_in') {
							document.location = Adzuki.base_uri + '/MyTrips/login';
						}
					});
				}

				$(this).addClass('favorite-click');

				setTimeout(function removeThatWiggle() {
					$('.favorite').removeClass('favorite-click');
				}, 1100);
			});
		}
	});

}(jQuery, window.Adzuki || {}));